import _get from 'lodash/get';

export interface LubricantCategoryListItem {
  id: number;
  categoryName: string;
  primary: string;
  sortOrder: number;
  sumpTank: string;
}

interface LubricantCategoriesApiParser {
  LubricantCategoriesListParser: (_res: any) => LubricantCategoryListItem[];
}

const lubricantCategoriesApiParser: LubricantCategoriesApiParser = {
  LubricantCategoriesListParser: (_res: unknown): LubricantCategoryListItem[] => {
    // Parse the API response structure
    const responseData = _get(_res, 'data', {});
    const content = _get(responseData, 'content', []);

    // Transform API data to match the expected grid structure
    const data: LubricantCategoryListItem[] = content.map((item: any) => ({
      id: Number(_get(item, 'id', 0)),
      categoryName: _get(item, 'name', ''), // API field 'name' maps to 'categoryName'
      primary: Boolean(_get(item, 'primary', false)) === true ? 'Active' : 'Inactive',
      sortOrder: Number(_get(item, 'showOrder', 0)), // API field 'showOrder' maps to 'sortOrder'
      sumpTank: Boolean(_get(item, 'sumpTank', false)) === true ? 'Active' : 'Inactive',
    }));

    return data;
  },
};

export default lubricantCategoriesApiParser;

// --------------- Category-specific types and data ---------------

export interface LubricantCategoryItem {
  id: number;
  categoryName: string;
  primary: boolean;
  sortOrder: number;
  sumpTank: boolean;
}

export interface LubricantCategoriesData {
  categories: LubricantCategoryItem[];
}
